// format locale from DatoCMS like "ar-AE" to an expected format "ae-ar"

export const useFormatLocale = (locale: string) => locale.toLowerCase().split("-").reverse().join("-")
